import { motion } from "framer-motion";
import { ease } from "../lib/content";

const VIEW = { once: true, amount: 0.15 };

export const Reveal = ({ children, className = "", delay = 0, y = 36, as = "div", ...rest }) => {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={VIEW}
      transition={{ duration: 0.9, ease, delay }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

const lineVariants = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.1, ease, delay: i } }),
};

// Masked line-by-line reveal; observer sits on the unclipped wrapper.
export const MaskLines = ({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.11, onLoad = false, as = "h2", testId }) => {
  const Tag = motion[as];
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: VIEW };
  return (
    <Tag className={className} initial="hidden" {...trigger} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em]">
          <motion.span className={`block ${lineClassName}`} variants={lineVariants} custom={delay + i * stagger}>
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const MaskWords = ({ text, className = "", highlight = [] }) => {
  const words = text.split(" ");
  return (
    <motion.p className={className} initial="hidden" whileInView="show" viewport={VIEW}>
      {words.map((w, i) => (
        <span key={i} className="-mb-[0.16em] mr-[0.25em] inline-block overflow-hidden pb-[0.16em] align-top">
          <motion.span
            className={`inline-block ${highlight.includes(w.replace(/[,.]/g, "")) ? "text-moss" : ""}`}
            variants={lineVariants}
            custom={i * 0.018}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </motion.p>
  );
};
